import { z } from 'zod'

import {
  PermissionLevel,
  PermissionScope,
  PermissionType,
} from '../constants/permission'
import { dbEntitySchema } from './system'

export const permissionConstraintSchema = z.object({
  key: z.string(),
  value: z.any(),
})

export const organizationPermissionSchema = dbEntitySchema.extend({
  user: z.string().optional().nullable(),
  name: z.string(),
  value: z.nativeEnum(PermissionType),
  createdByUser: z.string().optional().nullable(),
  organization: z.string(),
  organizationMember: z.string(),
  managementUser: z.string(),
  venue: z.string().optional().nullable(),
  level: z.nativeEnum(PermissionLevel),
  scope: z.nativeEnum(PermissionScope),
  constraints: z
    .array(permissionConstraintSchema.partial())
    .optional()
    .nullable(),
})

export const permissionCreateBodySchema = organizationPermissionSchema
  .omit({
    _id: true,
    deleted: true,
    modified: true,
    created: true,
    id: true,
    name: true,
    level: true,
    scope: true,
    organizationMember: true,
    organization: true,
    managementUser: true,
    venue: true,
  })
  .extend({
    organizationMemberId: z.string(),
    organizationId: z.string(),
    managementUserId: z.string(),
    venueId: z.string().optional().nullable(),
  })
